import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Tâches de fond (worker) lancées depuis ce navigateur et pas encore terminées.
 * WorkerJobsWatcher (monté dans le layout) les suit où que l'on soit dans l'app et prévient
 * à la fin. Persisté : un rechargement de page ne fait pas perdre le suivi.
 */
export const useWorkerJobsStore = create(
  persist(
    (set) => ({
      jobs: [],
      track: (job) =>
        set((state) => ({
          jobs: [...state.jobs.filter((j) => j.id !== job.id), { ...job, trackedAt: Date.now() }],
        })),
      untrack: (id) => set((state) => ({ jobs: state.jobs.filter((j) => j.id !== id) })),
    }),
    { name: 'worker-jobs' }
  )
)
